// pages/treach/sections/ReportsSection.jsx
import React from "react";

const ReportsSection = () => {
  return (
    <div className="text-gray-200 text-sm">
      <p>📊 <strong>Analytics Snapshot</strong></p>
      <ul className="list-disc list-inside mt-3 text-gray-400">
        <li>Impressions: 1,200,000</li>
        <li>Engagement: 4.5%</li>
        <li>Conversions: 3,200</li>
      </ul>
    </div>
  );
};

export default ReportsSection;
